import React from "react";
import { Button } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import {useLocation} from "react-router-dom";
import AppContext from "../../context/app/context";
import PageHeader from "../../components/general/layout/page-header";
import styles from "./style.module.scss";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import CompanyTable from "../../components/companies/company-table";
import TrademarkContext from "../../context/trademark/context";
import TrademarkContextProvider from "../../context/trademark/provider";

const Companies: React.FC = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);

  const { actions, loading, query } = useContext(TrademarkContext);
  const [isSortingEnabled, setIsSortingEnabled] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const location = useLocation();

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("companies")}
        subTitle={t("arrangement_companies_in_category")}
        extra={[
          <RefreshBtn
            key={0}
            loading={tableLoading}
            onClick={() => setRefreshTrigger(!refreshTrigger)}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Can key={1} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                setIsSortingEnabled(!isSortingEnabled);
              }}
            >
              {isSortingEnabled ? t("disable_sorting") : t("enable_sorting")}
            </Button>
          </Can>,
        ]}
      />
      <CompanyTable
        isSortingEnabled={isSortingEnabled}
        categoryId={location.state?.categoryId}
        freeDelivery={location.state?.freeDelivery}
        discountOffer={location.state?.discountOffer}
        refreshTrigger={refreshTrigger}
        onLoadingChange={setTableLoading}
      />
    </div>
  );
};

const CategoryCompaniesPage = () => {
  return (
    <TrademarkContextProvider>
      <Companies />
    </TrademarkContextProvider>
  );
};

export default CategoryCompaniesPage;